import { Tabs } from '@material-ui/core'
import React, { useEffect } from 'react'
import TabWithPermissions from '../tabWithPermissions/tabWithPermissions'

export interface Tab {
  label: string
  hasPermission: boolean
  id?: number
}

interface TabsWithPermissionsProps {
  tabs: Map<number, Tab>
  tabDefault?: number
  onTabChange: (tab: number) => any
  hideTabs?: boolean
}

const TabsWithPermissions: React.FC<TabsWithPermissionsProps> = ({
  tabDefault = 0, // idx
  tabs,
  onTabChange,
  hideTabs = false
}) => {
  useEffect(() => {
    onTabChange(tabDefault)
  }, [])

  const [activeTab, setActiveTab] = React.useState<number>(tabDefault)

  useEffect(() => {
    setActiveTab(tabDefault)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabDefault, tabs])

  const handleTabChange = (event: React.ChangeEvent<{}>, tab: number) => {
    onTabChange(tab)
    setActiveTab(tab)
  }

  if (hideTabs) {
    return null
  }

  return (
    <Tabs
      value={activeTab > tabs.size ? tabDefault : activeTab}
      onChange={handleTabChange}
      aria-label="scrollable auto tabs"
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
    >
      {[...tabs.keys()].map(idx => {
        const tab = tabs.get(idx)

        return tab?.hasPermission ? (
          <TabWithPermissions
            key={`${+idx}`}
            label={tab?.label}
            hasPermission={tab?.hasPermission}
          ></TabWithPermissions>
        ) : null
      })}
    </Tabs>
  )
}

export default TabsWithPermissions
